// Module
var code = "<div class=\"landing-page-info-message tw-mt-5\">\n    <svg width=\"8\" height=\"9\" viewBox=\"0 0 8 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <circle cx=\"3.8789\" cy=\"4.52929\" r=\"3.79296\" fill=\"black\"/>\n    </svg>\n\n    <p class=\"landing-page-info-message__body tw-font-normal\" ng-transclude></p>\n</div>\n";
// Exports
module.exports = code;